<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Sumitted Detail</strong> <span class="float-right"> {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_status">Status</label>
                <br>
                <b-badge variant="success" v-if="model.is_done">applyed</b-badge>
                <b-badge v-else variant="secondary">Wait</b-badge>

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_source">Source : Regist request user</label>
                <div v-if="model && model.source">{{model.source}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_type">Content Type</label>
                <div v-if="model && model.category" v-html="model.category"></div>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_ext">Content Extension</label>
                <div v-if="model && model.ext" v-html="model.ext"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_filename">FileName</label>
                <div v-if="model && model.name" v-html="model.name"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <label for="ph_descript">Content</label>
              <span v-if="model && model.length">( bytes : {{model.length}} )</span>
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                Force Decode base64
              </b-button>
              <hr>
              <div v-if="model && model.data" v-html="content || model.data || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <b-button size="sm" variant="danger" @click="remove_confirm = true" style="margin:0 5px;"> Remove </b-button>
            <b-button size="sm" variant="success" @click="regist_confirm = true" style="margin:0 5px;"> Pattern Regist </b-button>
            <b-button size="sm" variant="primary" @click="download" style="margin:0 5px;"> Download </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell Regist"  class="modal-danger" v-model="remove_confirm" @ok="remove" ok-variant="danger">
      Would You Like to delete?
    </b-modal>
    <b-modal title="Webshell Regist"  class="modal-warning" v-model="regist_confirm" @ok="add" ok-variant="warning">
      Would You Like to Regist?
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import forge from 'node-forge'
import { saveAs } from 'file-saver/FileSaver';

export default {
  data : () => {
    return {
      remove_confirm : false,
      regist_confirm : false,
      lock: true,
      decrypted : false,
      model : {},
      content : '',
    }
  },
  methods: {
    decrypt : function() {
      try {
        // 바이너리일 경우 강제 내용 보기
        let content = forge.util.decode64(this.model.data)
        try {
          this.content = forge.util.decodeUtf8(content) // 한글 처리
        } catch (error) { this.content = unescape(content) }

      } catch (e) { this.$toastr.e('decode failed', 'not support this format') }
      finally { this.decrypted = true }
    },
    download: function(){
      let blob = new Blob([this.model.data], {type: "text/plain;charset=utf-8"});
      saveAs(blob, this.model.name+'.F1');
    },
    async remove() {
      try{
        let rs = await Api.Manager_Call('wsfinder.webshell.temp', 'delete', { id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('delete.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async add() {
      try{
        let rs = await Api.Manager_Call('wsfinder.webshell.temp', 'regist', { id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('add', this.$route.name);
        } else {
          this.$toastr.e('add', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    list: function() { this.$router.push({ name: 'wsfinder_regist'}); },
    get: function(id = this.$route.params.id) {
      console.log('regist.detail.vue', 'load item', id);
      return Api.Manager_Call('wsfinder.webshell.temp', 'detail', {id : id})
        .then(rs => {
          this.model = Object.assign({}, this.model, rs.body);

          if (this.model.is_binary){ console.log('is_binary'); }
          else {
            let data = forge.util.decode64(this.model.data, 'base64');
            this.model.data = forge.util.decodeUtf8(data)
          }
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('regist.detail.vue', 'created'); },
  destroyed: function() { console.log('regist.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('regist.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}
</script>
